import { render, staticRenderFns } from "./jianchaku.vue?vue&type=template&id=5dbc3d2f&scoped=true"
import script from "./jianchaku.vue?vue&type=script&lang=ts"
export * from "./jianchaku.vue?vue&type=script&lang=ts"
import style0 from "./jianchaku.vue?vue&type=style&index=0&id=5dbc3d2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc3d2f",
  null
  
)

export default component.exports